"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyBillingPlanType = void 0;
var CompanyBillingPlanType;
(function (CompanyBillingPlanType) {
    CompanyBillingPlanType["PREEXISTING"] = "preexisting";
    CompanyBillingPlanType["CUSTOM"] = "custom";
})(CompanyBillingPlanType = exports.CompanyBillingPlanType || (exports.CompanyBillingPlanType = {}));
